import ProgressDots from "./ProgressDots";
import { COLORS, SIZES } from "./utilities";

export { COLORS, SIZES };
export default ProgressDots;
